import { render, staticRenderFns } from "./Logotype.vue?vue&type=template&id=a0f17a60&scoped=true"
import script from "./Logotype.vue?vue&type=script&lang=js"
export * from "./Logotype.vue?vue&type=script&lang=js"
import style0 from "./Logotype.vue?vue&type=style&index=0&id=a0f17a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f17a60",
  null
  
)

export default component.exports